import { all, fork } from "redux-saga/effects";
import { signInSaga } from "./signin/sagas";
import { userSaga } from "./users/sagas";
import { roleSaga } from "./roles/sagas";
import { clientsSaga } from "./clients/sagas";
import { inspectionFirmsSaga } from "./inspection-firms/sagas";
import { formTemplatesSaga } from "./form-templates/sagas";
import { ordersSaga } from "./orders/sagas";
import { propertySaga } from "./properties/sagas";
import { locationSaga } from "./locations/sagas";

const rootSaga = function* () {
  yield all([
    fork(signInSaga),
    fork(userSaga),
    fork(roleSaga),
    fork(clientsSaga),
    fork(inspectionFirmsSaga),
    fork(formTemplatesSaga),
    fork(ordersSaga),
    fork(propertySaga),
    fork(locationSaga),
  ]);
};

export default rootSaga;
